import { useContext } from 'react'
import { ApplicationStoreContext } from './ApplicationStoreProvider'

const useApplicationStore = () => useContext(ApplicationStoreContext)
export default useApplicationStore
